export default class ResponseModel {
    code: 0 | 1 = 0 // 状态码
    data: any = null // 数据
    msg: string = ''// 提示语
}
